import type { IconProps } from './types';

export const CodeBracketIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M6.78949 6.96477C7.08407 6.72447 7.51879 6.74193 7.7934 7.01653C8.068 7.29114 8.08546 7.72586 7.84515 8.02044L7.7934 8.07708L3.87054 11.9999L7.7934 15.9228L7.84515 15.9794C8.08543 16.274 8.06798 16.7087 7.7934 16.9833C7.5188 17.2579 7.08406 17.2754 6.78949 17.0351L6.73285 16.9833L2.27972 12.5302C2.13907 12.3896 2.06 12.1988 2.06 11.9999C2.06 11.801 2.13907 11.6103 2.27972 11.4697L6.73285 7.01653L6.78949 6.96477Z"
        fill={color}
      />
      <path
        d="M16.2089 7.0166C16.4835 6.742 16.9182 6.72453 17.2128 6.96484L17.2695 7.0166L21.7226 11.4697C21.8633 11.6104 21.9423 11.8011 21.9423 12C21.9423 12.1989 21.8633 12.3896 21.7226 12.5303L17.2695 16.9834C16.9766 17.2762 16.5018 17.2762 16.2089 16.9834C15.916 16.6905 15.9161 16.2157 16.2089 15.9229L20.1318 12L16.2089 8.07715L16.1572 8.02051C15.9169 7.72593 15.9343 7.29121 16.2089 7.0166Z"
        fill={color}
      />
      <path
        d="M13.8061 4.22705C13.9621 3.88062 14.3578 3.70129 14.726 3.82373C15.119 3.95472 15.3316 4.37999 15.2006 4.77295L10.225 19.7017C10.094 20.0945 9.66873 20.3063 9.27582 20.1753C8.88306 20.0442 8.67034 19.6199 8.80121 19.2271L13.7778 4.29834L13.8061 4.22705Z"
        fill={color}
      />
    </svg>
  );
};
